import { css } from '@emotion/react';
import { LoaderPro } from '@treatwell/treatwell-aura';
import { useEffect } from 'react';
import {
  NUMBER_OF_STEPS,
  getStepConfiguration,
  useFormContext,
} from '../state';
import { deleteLeadInfoCookie, getLeadInfoCookie } from '../helpers/cookie';
import {
  ElementWrapperTemplate,
  FooterTemplate,
  HeaderTemplate,
  MainTemplate,
  ProgressTemplate,
} from './templates';

function Progress(): JSX.Element {
  const { step } = useFormContext();
  const { progress } = getStepConfiguration(step);

  return <ProgressTemplate progress={(progress * 100) / NUMBER_OF_STEPS} />;
}

function Loader(props: { display: boolean }): JSX.Element {
  const { display } = props;
  return (
    <div css={css({ marginTop: 150, display: display ? 'block' : 'none' })}>
      <LoaderPro />
    </div>
  );
}

function ElementWrapper(props: { display: boolean }): JSX.Element {
  const { display } = props;
  const { step } = useFormContext();
  const { Element } = getStepConfiguration(step);

  return (
    <ElementWrapperTemplate display={display} ElementComponent={Element} />
  );
}

function Content() {
  const { loading } = useFormContext();

  return (
    <>
      <Loader display={loading} />
      <ElementWrapper display={!loading} />
    </>
  );
}

function Footer() {
  const { onPrevious, onNext, step } = useFormContext();
  const { nextKey, previousKey, leftComponent } = getStepConfiguration(step);

  return (
    <FooterTemplate
      onPrevious={onPrevious}
      onNext={onNext}
      nextKey={nextKey}
      previousKey={previousKey}
      leftComponent={leftComponent}
    />
  );
}

export function Main(): JSX.Element {
  const { setData, hasInitialized } = useFormContext();

  useEffect(() => {
    if (!hasInitialized) {
      return;
    }

    const leadInfo = getLeadInfoCookie();
    if (leadInfo) {
      setData(current => {
        const cookieData = {
          ...current,
          businessName: leadInfo.salon_name || '',
          email: leadInfo.email || '',
          firstName: leadInfo.first_name || '',
          lastName: leadInfo.last_name || '',
          phoneNumber: leadInfo.phone || '',
        };

        if (leadInfo.leadId) {
          cookieData.leadId = leadInfo.leadId;
        }

        return cookieData;
      });
      deleteLeadInfoCookie();
    }
  }, [setData, hasInitialized]);

  return (
    <MainTemplate
      HeaderComponent={HeaderTemplate}
      ProgressComponent={Progress}
      ContentComponent={Content}
      FooterComponent={Footer}
    />
  );
}
